(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["share"] && !Shopify.designMode) return;
  try {
    class ShareButtons extends HTMLElement {
    connectedCallback() {
      this.copyButton = this.querySelector('[data-copy]');
      this.toast = this.querySelector('[data-copy-toast]');
      if (this.copyButton) {
        this.copyButton.addEventListener('click', () => this.copyLink());
      }
    }

    async copyLink() {
      const url = this.dataset.shareUrl;
      if (!url) return;
      try {
        await navigator.clipboard.writeText(url);
      } catch (error) {
        const temp = document.createElement('textarea');
        temp.value = url;
        temp.setAttribute('readonly', '');
        temp.style.position = 'absolute';
        temp.style.left = '-9999px';
        document.body.appendChild(temp);
        temp.select();
        document.execCommand('copy');
        document.body.removeChild(temp);
      }
      this.showToast();
    }

    showToast() {
      if (!this.toast) return;
      this.toast.hidden = false;
      clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.toast.hidden = true;
      }, 2000);
    }
  }

  if (!customElements.get('share-buttons')) {
    customElements.define('share-buttons', ShareButtons);
  }
  } catch(e) { console.error(e); }
})();

})();
